import request from '@/utils/request'

export function getRoomBookingDetailApi(id) {
  return request({
    url: `/booking-service/v1/booking/room-booking/${id}`,
    method: 'get'
  })
}

export function getBookingTravellerListApi(id) {
  return request({
    url: `/booking-service/v1/booking/${id}/travellers`,
    method: 'get'
  })
}

/** Use for set room status
 * @param {Object} payload
 * @param {Number} payload.room_status
 * @param {Array} payload.room_ids
 */
export function setRoomStatusApi(payload) {
  return request({
    url: `/chamber-service/v1/housekeeping`,
    method: 'put',
    data: payload
  })
}

export function checkInBookingApi(payload) {
  return request({
    url: `/booking-service/v1/booking/check-in`,
    method: 'post',
    data: payload
  })
}

export function updateRoomBookingApi(id, payload) {
  return request({
    url: `/booking-service/v1/booking/update-room-booking/${id}`,
    method: 'put',
    data: payload
  })
}
